import { useFieldHelper } from 'framework/ui/field';
import React from 'react';
import { Typography } from '@mui/material';
import { TypographyProps } from '@mui/material/Typography';

const NotLinkedToMilestoneField = ({ source, ...props }: TypographyProps<any> & { source: string }) => {
  const { getValue } = useFieldHelper<string[]>({ source });
  const milestones = getValue();
  const displayedValue = milestones?.length > 0 ? '' : 'Not linked to a specific milestone(s)';

  return <Typography {...props}>{displayedValue}</Typography>;
};
export default NotLinkedToMilestoneField;
